import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import GrassIcon from "@mui/icons-material/Grass";
import PetsIcon from "@mui/icons-material/Pets";
import ForestIcon from "@mui/icons-material/Forest";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const FarmTypeSelectModal = ({ open, onClose, onSelect, selectedValue }) => {
  // Liste des types d'exploitation avec icônes
  const farmTypes = [
    { id: "maraichage", name: "Maraîchage", icon: <LocalFloristIcon /> },
    { id: "cereales", name: "Céréales", icon: <GrassIcon /> },
    { id: "elevage", name: "Élevage", icon: <PetsIcon /> },
    { id: "arboriculture", name: "Arboriculture", icon: <ForestIcon /> },
    { id: "viticulture", name: "Viticulture", icon: <AgricultureIcon /> },
    { id: "autre", name: "Autre", icon: <HelpOutlineIcon /> },
  ];

  const handleSelect = (typeId) => {
    onSelect(typeId);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: "8px",
          width: "90%",
          maxWidth: "400px",
          maxHeight: "80vh",
          overflow: "auto",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
          Sélectionnez un type d'exploitation
        </Typography>

        <List sx={{ mb: 2 }}>
          {farmTypes.map((type) => (
            <ListItem key={type.id} disablePadding>
              <ListItemButton
                onClick={() => handleSelect(type.id)}
                selected={selectedValue === type.id}
                sx={{
                  borderRadius: "4px",
                  mb: 1,
                  bgcolor: selectedValue === type.id ? "primary.light" : "background.paper",
                  "&:hover": {
                    bgcolor: "primary.light",
                  },
                }}
              >
                <ListItemIcon>{type.icon}</ListItemIcon>
                <ListItemText primary={type.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Button
          variant="outlined"
          color="primary"
          onClick={onClose}
          fullWidth
          sx={{ mt: 1 }}
        >
          Annuler
        </Button>
      </Box>
    </Modal>
  );
};

export default FarmTypeSelectModal;